<template lang="pug">
  BaseForm(
    :title="title"
    :routeKey="routeKey"
    :routes="routes"
    :form="form"
    :data="item"
    :update="updateItem"
    :create="createItem"
  )
</template>

<script>
import BaseForm from '@/components/app/BaseForm'
import { mapState, mapActions } from 'vuex'
import store from '@/store'

export default {
  components: { BaseForm },
  data: (vm) => ({
    title: vm.$t('site_versions.create')
  }),
  computed: {
    ...mapState('siteVersions', ['routeKey', 'routes', 'form', 'item']),
    crumbs: (vm) => [
      { text: vm.$t('site_versions.title'), to: { name: 'site-versions.index' } },
      { text: vm.$t('site_versions.create') }
    ]
  },
  async beforeRouteEnter (to, from, next) {
    try {
      await store.dispatch('siteVersions/clearItem')
      await store.dispatch('siteVersions/fetchEnums')
      next()
    } catch (error) {
      next(error)
    }
  },
  methods: {
    ...mapActions('siteVersions', ['createItem', 'updateItem'])
  }
}
</script>
